// extracted by mini-css-extract-plugin
export default {"container":"LikesCounter_container__5brEO"};